/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { ExtensionsStore } from '../stores/extensionsStore';

export const useExtensionsStore = () =>
  useContext<{
    extensionsStore: ExtensionsStore;
  }>(StoreContext);
